<template>
    <div>

        <div class="mcc-page-header">
            <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
                <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                    <section class="mu-d-flex ">
                        <h1 class="mu-mb-00">Process instance</h1>
                        <details class="mcc-popover mcc-popover--bottom-end">
                            <summary class="mcc-button mcc-button--icon-only">
                                <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                            </summary>
                            <div class="mcc-popover__content">
                                <p class="mu-mb-00">
                                    {{ helpText.title }}
                                    <a :href="helpText.url" target="_blank">Read more...</a>
                                </p>
                            </div>
                        </details>
                    </section>
                    <section>
                        <div role="group" class="mcc-button-group mcc-button-group--spaced"
                            id="instanceViewHeadersButtons" v-show="showProcesses && fetchCall">
                            <details class="mcc-dropdown spacing" id="exportAsPDF" title="Export as PDF" tooltip="">

                                <summary aria-haspopup="true">
                                    <div class="mcc-button mcc-button--outline">
                                        <mcc-icon name="export" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Export as PDF</span>
                                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow"
                                            aria-hidden="true"></mcc-icon>
                                    </div>
                                </summary>
                                <ul class="mcc-dropdown__menu">
                                    <li v-for="process in processList" :key="process.instanceId">
                                        <button @click="exportAsPDF(process.instanceId)" class="mcc-button__label">
                                            {{ process.name || 'Unnamed Process' }}
                                        </button>
                                    </li>
                                </ul>
                            </details>
                            <button @click="$refs.processDetailsdialogRef.show()" type="button"
                                class="mcc-button mcc-button--outline" id="processDetails" title="Process details"
                                dialog="processDetails-dialog">
                                <mcc-icon name="info" aria-hidden="true"></mcc-icon><span
                                    class="mcc-button__label">Process details</span>
                            </button>
                            <button @click="$refs.terminateProcConfDialogRef.show()"
                                class="mcc-button mcc-button--danger" v-if="!isCompleted && isAdmin"
                                id="terminateInstance" title="Terminate process" dialog="terminateProcConfDialog">
                                <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span
                                    class="mcc-button__label">Terminate process</span>
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li v-if="menu == 'all'">Process engine</li>
                    <li v-if="menu == 'all'">
                        <a class="table-link" @click="redirectToList()">Instances</a>
                    </li>
                    <li v-if="menu == 'startedbyme'">
                        <a class="table-link" @click="redirectToList()">Started by me</a>
                    </li>
                    <li v-if="menu == 'involvingme'">
                        <a class="table-link" @click="redirectToList()">All involved</a>
                    </li>
                    <li><b>{{ processName }} </b></li>
                </ol>
            </nav>
            <div class="mcc-row" v-if="!fetchCall || !showProcesses">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-container mu-m-06">
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div class="mcc-card">
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <ul class="mcc-list-group mcc-list-group-v1" v-show="showProcesses && fetchCall">
                                            <li v-for="(app, key) in processList" :key="key" class="mcc-list-group-li">

                                                <details class="mcc-collapse mu-w-100" :id="'collapseProcess' + key"
                                                    :ref="'collapseProcess' + key">
                                                    <summary @click="handleExpand(key, app.instanceId)">
                                                        <div class="mcc-menu__button">
                                                            <b><span
                                                                    v-html="formatAppName(app.name, app.instanceId)"></span></b>
                                                        </div>
                                                        <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow"
                                                            aria-hidden="true"></mcc-icon>
                                                    </summary>
                                                    
                                                    <div>
                                                        <div :id="'myTable' + key">
                                                            <keep-alive include="ProcessInstanceDetails">
                                                                <component v-if="tableObj[key]"
                                                                    :is="tableObj[key].component"
                                                                    v-bind="tableObj[key].props"
                                                                    :ref="'myTableRef' + key"
                                                                    @process-steps-links-ready="addLinkToSubProcess(key, app.instanceId)" />
                                                            </keep-alive>

                                                        </div>
                                                    </div>

                                                </details>

                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            <div class="mcc-dialog-overlay" v-show="showProcesses && fetchCall">
                <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" v-if="!isCompleted && isAdmin"
                    color="warning" id="terminateProcConfDialog" ref="terminateProcConfDialogRef">
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Terminate process</h2>
                            <button type="button"
                                class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                                @click="$refs.terminateProcConfDialogRef.close()">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    Are you sure you want to terminate this process instance?
                                </div>
                            </div>
                        </div>
                        <div class="mcc-dialog__footer">

                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" id="noTerminateProcBtn" class="mcc-button mcc-button--outline"
                                    @click="$refs.terminateProcConfDialogRef.close()">No</button>
                                <button type="button" id="yesTerminateProcBtn" class="mcc-button mcc-button--warning"
                                    @click="handleTerminateProcDialogClose($event)">Yes</button>
                            </div>
                        </div>
                    </section>
                </dialog>
            </div>
            <div class="mcc-dialog-overlay" v-show="showProcesses && fetchCall">
                <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" id="processDetails-dialog"
                    ref="processDetailsdialogRef">
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Process details</h2> <button type="button"
                                class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                                @click="$refs.processDetailsdialogRef.close()">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>

                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="processContainer">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <mcc-alert role="alert"
                                                    class="mcc-alert mcc-alert--info mcc-alert--compact">
                                                    <mcc-icon name="info_popup" aria-hidden="true"
                                                        icon-set="fluency-filled"></mcc-icon>
                                                    <div>
                                                        <span class="mu-fw-semi-bold"> {{ ` Started by ${startUserId} -
                                                            ${startTime} ` }}</span>
                                                    </div>
                                                    <div v-if="endTime != null">
                                                        <span class="mu-fw-semi-bold"> {{ `Completed - ${endTime} `
                                                            }}</span>
                                                    </div>
                                                    <div v-if="durationInMillis != null">
                                                        <span class="mu-fw-semi-bold"> {{ `Completed in
                                                            ${durationInMillis} ` }}</span>
                                                    </div>
                                                </mcc-alert>
                                            </div>
                                        </div>
                                        <div v-for="(obj, index) in processDetails" :key="index" class="mu-my-03">
                                            <div class="mcc-row">
                                                <div class="mcc-col">
                                                    <span>{{ obj.key }}</span>
                                                </div>
                                                <div class="mcc-col">

                                                    <span>{{ obj.value }}</span>
                                                </div>
                                            </div>
                                            <div class="seperator mu-mt-03" v-if="index != processDetails.length - 1">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-dialog__footer">
                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--info" id="processDetailsDialogBtn"
                                    @click="$refs.processDetailsdialogRef.close()">Close</button>
                            </div>
                        </div>
                    </section>
                </dialog>
            </div>
        </div>

    </div>
</template>

<script>

import constantMessages from "../../../messages";
import MyProcessListAPI from "../../../services/MyProcessListAPI";
import InstanceAPI from "../../../services/InstanceAPI.js";
import Drawer from '../../common/Drawer.vue';
import Utils from "@/script_utils";
import ProcessInstanceDetails from "@/components/processEngine/instances/ProcessInstanceDetails.vue";
import {
    EventBus
} from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
import { get } from "jquery";
export default {
    name: "ProcessInstanceScreen",
    components: {
        Drawer,
        ProcessInstanceDetails
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["myProcesses.startedByMe"],
            showProcesses: false,
            processList: [],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            searchCriteria: {},
            tableObj: {},
            tableObjDup: [],
            currentPageSize: [],
            pageType: "StartedByMe",
            involvingAll: false,
            title: "Process instance",
            updateCall: false,
            showNoRecords: false,
            updateCallTable: false,
            processListLoaded: false,
            selectInstanceEntities: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
            expandedKey: null,
            expandedProcessInstanceId: null,
            processName: "",
            instanceViewConfig: null,
            menu: this.$route.params.menu,
            processInstanceId: "",
            isCompleted: "",
            isAdmin: "",
            fetchCall: false,
            processDetails: [],
            processInfo: ""
        };
    },
    created() {
        let self = this;
        this.pageType = this.$route.name;
        //this.updatePageAppearance();
        this.selectInstanceEntities = new SlimSelect({
            select: '#InvolvingselectId',

        })
        //this.flatPickr();

    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.getInstanceDetails();
        MyProcessListAPI.getUsers();
        this.getSubProcessData();
    },

    methods: {
        //API call to get the details about the primary process instance
        getInstanceDetails() {
            let self = this;
            InstanceAPI.getInstanceDetails(this.$route.params.instId, this.menu)
                .then(result => {
                    if (result == null) {
                        EventBus.$emit('error-notification', {
                            "msg": "Error while fetching instance details"
                        });
                        self.redirectToList();
                        return;
                    }
                    self.processVariables = result.processVariables;
                    self.startUserId = result.startUserId != null ? result.startUserId : 'SYSTEM';
                    self.startTime = Utils.getMomentDateString(result.startTime);
                    self.endTime = Utils.getMomentDateString(result.endTime);
                    self.durationInMillis = result.durationInMillis;
                    self.isCompleted = result.isCompleted;
                    self.isAdmin = result.isAdmin;
                    self.processInfo = result.processInfo;
                    this.processDetailShowHandler();
                })
                .finally(() => {
                    self.fetchCall = true;

                });
        },
        processDetailShowHandler() {
            this.processDetails = [{
                'key': 'Name',
                'value': this.processInfo.name
            },
            {
                'key': 'Description',
                'value': this.processInfo.description
            },
            {
                'key': 'Category',
                'value': this.processInfo.category
            },
            ];
        },
        //API call to get the sub process data for the primary process instance
        getSubProcessData() {
            let self = this;

            self.showProcesses = false;


            InstanceAPI.getSubProcessForInstance(this.$route.params.instId).then(result => {
                if (result == null) {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching sub process for instance"
                    });
                    self.redirectToList();
                    return;
                }
                self.processList = result;
                self.processListLoaded = true;
                self.showProcesses = result.length > 0;
                if (result.length == 0) {
                    self.showNoRecords = true;
                } else {
                    self.processName = self.processList[0].name;
                    self.processInstanceId = self.processList[0].instanceId;
                }
            });
        },
        // Handle the expand/collapse of process instance details
        handleExpand(key, instanceId) {
            const idx = this.processList.findIndex(item => item.instanceId === instanceId);
            this.initProcessInstanceDetails(idx, instanceId);
        },
        // Add click listener to the sub process links in the table
        // This will allow navigation to the details of the sub process when clicked
        addLinkToSubProcess(key, instanceId) {
            const tableElement = document.getElementById('processStepsTableRef' + key);
            if (!tableElement) return;

            // Remove any previous listener to avoid duplicates
            tableElement.onclick = null;

            // Attach a single click listener to the table
            tableElement.onclick = (e) => {
                const target = e.target;
                if (target.classList && target.classList.contains("name-link")) {
                    const processInstanceId = target.getAttribute("data-id");
                    if (processInstanceId) {
                        this.callFromSubProcessLink(key, processInstanceId);
                    }
                }
            };
        },
        // This function is called when a sub process link is clicked
        // It expands the details of the sub process and scrolls to it
        callFromSubProcessLink(key, instanceId) {
            const idx = this.processList.findIndex(item => item.instanceId === instanceId);
            const details = document.getElementById('collapseProcess' + idx);
            if (details) {
                if (!details.open) {
                    const summary = details.querySelector('summary');
                    if (summary) summary.click();
                }

            }
            this.$nextTick(() => {
                const element  = this.$refs['collapseProcess' + idx]?.[0];
                const container  = document.querySelector('.mcc-drawer-app-content'); // update this selector
                const headerOffset = 280; // height of your fixed header inside the scrollable container
                if (element && container) {
                    const offset = 80;
                    const containerTop = container.getBoundingClientRect().top;
                    const elementTop = element.getBoundingClientRect().top;
                    const scrollTo = 8 +container.scrollTop + (elementTop - containerTop) - offset;
                    container.scrollTo({
                        top: scrollTo,
                        behavior: 'smooth',
                    });
                }
            });
        },
        // Initialize the process instance details component
        // This will either set the component from the cache or create a new one
        initProcessInstanceDetails(key, instanceId) {
            if (this.tableObj[key] == null) {
                this.updateCallTable = false;
                if (this.tableObjDup[key]) {
                    this.tableObj[key] = this.tableObjDup[key];
                } else {
                    this.$set(this.tableObj, key, {
                        component: 'ProcessInstanceDetails',
                        props: {
                            id: String(key),
                            key: instanceId,
                            menu: self.menu,
                            instanceId: instanceId
                        }
                    });
                }

                this.tableObjDup[key] = this.tableObj[key];
            } else {
                this.tableObj[key] = null;
            }
        },
        // Redirect to the list of process instances based on the menu type
        redirectToList() {
            if (this.menu == 'all') {
                localStorage.setItem("instanceList", "instanceList");
                this.$router.push(
                    this.CONTEXT_PATH + '/processengine/processes'
                );
            } else {
                localStorage.setItem(this.menu + "Processes", this.menu);
                this.$router.push(
                    this.CONTEXT_PATH + '/processes/' + this.menu
                );
            }
        },
        // Format the application name with step name if available
        formatAppName(name, instanceId) {
            if (instanceId && instanceId.trim() !== "") {
                return `${name}&nbsp;&nbsp;(${instanceId})`;
            }
            return name;
        },
        // Handle the event of the terminate process
        handleTerminateProcDialogClose(e) {
            let self = this;
            self.$refs.terminateProcConfDialogRef.close()
            InstanceAPI.terminateProcessInstance(self.processInstanceId).then(response => {
                if (response != null && response.error == false) {
                    if (response.error) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.redirectToList();
                    }
                }
            });
        },
        exportAsPDF(instanceId) {
            return InstanceAPI.exportAsPDF(instanceId, this.menu);
        },
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}


.mcc-list-group-li {
    border-bottom: 1px solid #666679;
}

.mcc-list-group {
    border-top: 1px solid #666679;
    border-left: 1px solid #666679;
    border-right: 1px solid #666679;
}
.mcc-list-group-v1 {
    border: none !important;
    list-style-type: none;
    --mds-list-group-base-border-width: 0px !important;
    --mds-list-group-base-border-radius: var(--mds-list-group-border-radius, 0rem);
}
.spacing {
  margin-right: 16px;
}
</style>
